import React from "react";
import { useCurrencyFormatter } from "../../hooks/useCurrencyFormatter";
import { MetricComponentProps } from "../../types/metrics";
import MetricItem from "./MetricItem";
import {
  formatMonthlyPayment,
  getMonthlyPaymentTooltip,
} from "./metricHelpers";

export default function MonthlyPaymentPrimaryMetric({
  sim,
}: MetricComponentProps) {
  const c = useCurrencyFormatter();

  return (
    <MetricItem
      value={formatMonthlyPayment(sim, c, true)}
      tooltip={getMonthlyPaymentTooltip(sim)}
    />
  );
}
